import gql from 'graphql-tag'

export default gql`query ($office_id: Int){
  me{
    viewed_notifications_at
  }
  notifications(office_id: $office_id){
    id
    subject
    message
    user{
      user_id
      first_name
      last_name
    }
    popup
    updated_at
    active
  }
}`